const SurveyResult = {
  List: "/Tables/SurveyResult/List",
  Info: "/Tables/SurveyResult/Info",
  Export: "/Tables/SurveyResult/Export",
};

export default {
  SurveyResult,
};
